<template>
  <div class="form-group">
    <label :for="id" class="form-label"
      >{{ label
      }}<span v-if="mandatory" class="mandatory text-danger">*</span></label
    >
    <textarea
      v-if="multiline"
      :id="id"
      :class="classes"
      :rows="rows || 3"
      :placeholder="placeholder"
      :value="modelValue"
      :disabled="disabled"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
    <input
      v-else
      :id="id"
      type="text"
      :class="classes"
      :placeholder="placeholder"
      :value="modelValue"
      :disabled="disabled"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <slot name="validation"></slot>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
    label: String,
    modelValue: null,
    placeholder: String,
    multiline: Boolean,
    disabled: Boolean,
    rows: Number,
    mandatory: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes: function() {
      return `form-control ${this.disabled ? "disabled" : ""}`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";
.disabled {
  background-color: $gray-200;
}
.mandatory {
  margin-left: 5px;
}
</style>
